// extracted by mini-css-extract-plugin
export default {"xs":"GroupHeader_xs--mXY","s":"GroupHeader_s--ETc","m":"GroupHeader_m--t01"};